import { TelemetryTracker, ICodeSuggestionContextUpdate } from './tracking_types';
import { TRACKING_EVENTS } from './constants';

export class MultiTracker implements TelemetryTracker {
  #trackers: TelemetryTracker[] = [];

  constructor(trackers: TelemetryTracker[]) {
    this.#trackers = trackers;
  }

  get #enabledTrackers() {
    return this.#trackers.filter((t) => t.isEnabled());
  }

  isEnabled(): boolean {
    return Boolean(this.#enabledTrackers.length);
  }

  setCodeSuggestionsContext(
    uniqueTrackingId: string,
    context: Partial<ICodeSuggestionContextUpdate>,
  ) {
    this.#enabledTrackers.forEach((t) => t.setCodeSuggestionsContext(uniqueTrackingId, context));
  }

  updateCodeSuggestionsContext(
    uniqueTrackingId: string,
    contextUpdate: Partial<ICodeSuggestionContextUpdate>,
  ) {
    this.#enabledTrackers.forEach((t) =>
      t.updateCodeSuggestionsContext(uniqueTrackingId, contextUpdate),
    );
  }

  updateSuggestionState(uniqueTrackingId: string, newState: TRACKING_EVENTS) {
    this.#enabledTrackers.forEach((t) => t.updateSuggestionState(uniqueTrackingId, newState));
  }

  rejectOpenedSuggestions() {
    this.#enabledTrackers.forEach((t) => t.rejectOpenedSuggestions());
  }
}
